<template lang="pug">
  #create-establishment
    .new-establishment
      .title-block
        .title Nouvel établissement
        .subtitle Saisissez le nom de l'établissement que vous souhaitez créer
      .new-establishment-name-input
        input(
          type="text"
          v-model="name"
          placeholder="Nom du nouvel établissement"
          @keyup.enter="goNext"
        )
    .actions
      button.cancel-btn(@click="$emit('close')") Annuler
      button.previous-btn(@click="goBack") Precédent
      button.next-btn(@click="goNext" :disabled="!(name && name.length)") Suivant
</template>

<script>
export default {
  props: {
    newEstablishmentName: {
      type: String,
      require: true,
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'CreateOrMerge' });
    },
    goNext() {
      if (this.name && this.name.length) {
        this.$router.push({ name: 'ActionSummary' });
      }
    },
  },
  computed: {
    name: {
      get() {
        return this.newEstablishmentName;
      },
      set(value) {
        this.$emit('changeNewEstablishmentName', value);
      },
    },
  },
}
</script>

<style lang="scss">
  #create-establishment {
    .new-establishment {
      flex-grow: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .new-establishment-name-input {
        border: 1px solid #AAAAAA;
        border-radius: 8px;
        width: 320px;
        display: flex;
        color: #BABABA;
        margin-bottom: 1em;
        padding: .5em 1em;
        background: white;
        input {
          &::placeholder {
            color: #BABABA;
          }
          outline: none;
          font-size: 16px;
          border: none;
          width: 100%;
        }
      }
    }
  }
</style>